import { useBoundStore } from '@Store/index';
import { NameSuggestionModal } from './NameSuggestionModal';

export const NameSuggestionModalWrapper = () => {
  const isNameTooLongModalShown = useBoundStore(
    (state) => state.errorSlice.isNameTooLongModalShown
  );

  return <NameSuggestionModal isShown={isNameTooLongModalShown} />;
};

NameSuggestionModalWrapper.displayName = 'NameSuggestionModalWrapper';
